import axios from 'axios';

const url = process.env.VUE_APP_HOST;
const home = process.env.VUE_APP_HOME;

const getReport = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/ReportService/EventTemplate';

    let result = await axios.post(urlWithArg, payload ,headers);
    
    return result.data;

}


const getReportByEventId = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/ReportService/EventTemplate/'+payload.EventTemplateId;

    let result = await axios.post(urlWithArg, payload, headers);
    
    return result.data;

}



export const reportService = { getReport, getReportByEventId }


// WEBPACK FOOTER //
// ./src/api/report.service.js